class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.daysCounter = this.querySelector('[js-days-counter]');
    this.hoursCounter = this.querySelector('[js-hours-counter]');
    this.minCounter = this.querySelector('[js-min-counter]');
    this.secCounter = this.querySelector('[js-sec-counter]');
    this.startDate = new Date(this.getAttribute('data-start-date')).getTime();
    this.endDate = new Date(this.getAttribute('data-end-date')).getTime();
  }

  connectedCallback() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeRemaining = this.endDate - now;

    if (timeRemaining <= 0) {
      clearInterval(this.interval);
      this.daysCounter.textContent = '00';
      this.hoursCounter.textContent = '00';
      this.minCounter.textContent = '00';
      this.secCounter.textContent = '00';
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    this.daysCounter.textContent = this.formatTime(days);
    this.hoursCounter.textContent = this.formatTime(hours);
    this.minCounter.textContent = this.formatTime(minutes);
    this.secCounter.textContent = this.formatTime(seconds);
  }

  formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }
}

customElements.define('countdown-timer', CountdownTimer);